import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import styles from "./UploadImage.module.scss";
import UploadButton from "./UploadButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";

type UploadImageProps = {
    label?: string
    placeholder?: string
    varient?: string
    type?: string
    value?: string | number
    [key: string]: any
    required?: boolean
    style?: any
    labelFontWeight?: any
    disabled?: boolean
    icon?: string
    tooltipText?: any
    autoFocus?: any
    text?: string
    name: string
    description?: any
    subLabelStyle?: any
    handleModal?: any
    selectedFiles: any[]
    setSelectedFiles: any
    imagesData?: any
    setDeletedFiles: any
    isFetching?: boolean
}

const style = {
    margin: "16px 0px",
    "& .MuiTextField-root": {
        width: "100%",
    },
}

const UploadImage = (props: UploadImageProps) => {
    return <Box className={styles.upload_image_container}>
        <FormControl sx={props.style ? props.style : style}>
            <FormLabel
                disabled={props?.disabled}
                id={props?.name}
                sx={{ fontWeight: props?.labelFontWeight, width: "100%" }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "8px" }}>
                    <Typography>
                        {props?.label}
                    </Typography>
                    {props?.required && <Typography sx={{ color: "#E20000", fontSize: "14px", fontWeight: 500 }}>*</Typography>}
                    <FontAwesomeIcon icon={faCircleInfo} style={{ color: "#9A9EA5", cursor: "pointer" }} onClick={() => props?.handleModal(props?.name)} />
                </Box>
            </FormLabel>
            <UploadButton
                fieldName={props.name}
                selectedFiles={props.selectedFiles}
                setSelectedFiles={props.setSelectedFiles}
                error={props.error}
                helperText={props.helperText}
                imagesData={props?.imagesData}
                setDeletedFiles={props?.setDeletedFiles}
                isFetching={props?.isFetching}
            />
        </FormControl>
    </Box>
}
export default UploadImage;